G.BoardIce = function(board) {
  G.BoardLayer.call(this, board, {
    constructor: G.Ice,
    maxHp: 4,
    hpToken: true,
    editorSymbol: "ice",
    collectableType: "ice",
    blockMove: true,
    blockMatch: true,
    blockBoosterChange: true,
    stopHitPropagation: true,
  });
};

G.BoardIce.prototype = Object.create(G.BoardLayer.prototype);